import {Navigate} from "react-router-dom";

/**
 * Route guard.
 *
 * The real session lives in an httpOnly cookie that JavaScript cannot inspect, so
 * this only trusts the persisted login flag. That is safe: the flag cannot grant
 * access to anything by itself — if the cookie is missing or expired, the next API
 * call returns 401 and the axios interceptor logs the user out.
 */
const Protected = ({ isLoggedIn, children }: {isLoggedIn:any, children:any}) => {
    if (!isLoggedIn) {
        return <Navigate to="/" replace />;
    }
    return children;
};
export default Protected;
